<template>
	<section
		class="marketing-section text-color-white text-align-center-smo bg-color-content-primary pb-0 pt-300-md pt-0-smo"
	>
		<article class="container grid py-400 px-300-smo">
			<div
				class="col-12 col-7-md display-flex align-items-center justify-content-center-smo br-content-secondary-md"
			>
				<img
					v-if="!appStore.isMobile"
					v-reveal:fade-up
					class="qr-code"
					:src="qrCodeImg"
					alt="Image of a QR code that links to an app store to download the Fundrise app"
				/>
				<div class="mr-150-md">
					<h2 class="ff-ivar-display beta line-height-125 font-weight-lighter"
						>Diversification in&nbsp;<br v-if="appStore.isMobile" />the palm of your&nbsp;<br
							v-if="appStore.isMobile"
						/>hand</h2
					>
					<p v-if="!appStore.isMobile" class="delta">Scan the code to download the app.</p>
				</div>
			</div>

			<div
				class="app-reviews-container mt-300-smo col-12 col-5-md display-flex justify-content-space-between justify-content-center-smo align-items-flex-start flex-wrap-wrap-smo"
			>
				<div
					v-for="(appstoreInfo, idx) in appStoreInfo"
					:key="idx"
					v-reveal:fade-up
					class="app-store-info-container display-flex flex-direction-column justify-content-center-smo justify-content-space-between-md align-items-center"
				>
					<BaseSvgIcon :name="appstoreInfo.logoSvg" height="2rem" width="auto" class="text-color-white" />
					<RatingsStars :rating="appstoreInfo.reviewStars" class="block-align-center" />
					<p class="m-0">{{ appstoreInfo.reviewCount }} app reviews</p>
					<BaseLink v-if="appStore.isMobile" :link="{ href: appstoreInfo.storeUrl }">
						<BaseSvgIcon
							:name="appstoreInfo.buttonSvg"
							:title="appstoreInfo.buttonSvgAlt"
							height="2.5rem"
							width="auto"
						/>
					</BaseLink>
				</div>
			</div>

			<p class="col-12 mt-500 eta text-align-center text-color-greige">
				<BaseButton classes="link text-decoration-underline text-color-greige" @click="scrollToDisclaimer"
					>Learn more</BaseButton
				>
				about rating details.
			</p>
		</article>
	</section>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { appStoreInfo } from '@constants/app-ratings';
import RatingsStars from '@components/marketing-site/ratings-stars.vue';
import { scrollToAnchor } from '@utils/scroll-to';
import { useAppStore } from '@stores/app';

const appStore = useAppStore();

const qrCodeImg = appCloudfrontPath + '/images/marketing-site/download-app-qr-code.png';

function scrollToDisclaimer(): void {
	scrollToAnchor('socialStatsDisclaimers');
}
</script>
<style lang="scss" scoped>
@use '../../styles/utilities/respond-to.scss' as *;
@use '../../styles/constants/colors' as *;

.qr-code {
	height: 132px;
	width: 132px;
	margin-right: 2.25rem;
}

.app-reviews-container {
	.app-store-info-container {
		gap: 1rem;
	}

	@include respond-to(smo) {
		row-gap: 5em;

		.app-store-info-container {
			flex-basis: 100%;
		}
	}
}

@include respond-to(md) {
	.br-content-secondary-md {
		border-right: 1px solid token('content-secondary');
	}
}
</style>
